import { useState } from "react";
import { NavLink, Link } from "react-router-dom";

const navItems = [
  { label: "Home", to: "/" },
  { label: "Rooms", to: "/rooms" },
  { label: "Foods", to: "/foods" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

const BaseHeader = () => {
  const [isOpen, setIsOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `nav-link ${isActive ? "nav-link-active" : ""}`;

  return (
    <header className="sticky top-14 z-40 w-full border-b border-line/70 bg-white/85 backdrop-blur-xl">
      <div className="section-shell flex h-20 items-center justify-between gap-4">
        <Link to="/" className="group flex shrink-0 items-center gap-3" aria-label="GoTrip home">
          <img src="/media/logo/logo.png.webp" alt="GoTrip logo" className="h-9 w-auto" />
          <span className="hidden text-lg font-black tracking-tight text-ink xl:block">
            GoTrip
          </span>
        </Link>

        <nav className="hidden flex-1 items-center justify-center gap-1 md:!flex" aria-label="Primary navigation">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 xl:flex">
          <Link to="/rooms" className="btn-secondary">Explore stays</Link>
          <Link to="/foods" className="btn-primary">Book dining</Link>
        </div>

        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-line bg-white text-ink shadow-sm transition hover:bg-gotrip-50 focus:outline-none focus:ring-4 focus:ring-gotrip-100 md:!hidden"
          aria-label="Toggle menu"
          aria-expanded={isOpen}
        >
          <span className="sr-only">Toggle menu</span>
          <span className="relative h-5 w-5">
            <span className={`absolute left-0 top-0.5 h-0.5 w-5 rounded-full bg-ink transition duration-200 ${isOpen ? "rotate-45 translate-y-2" : ""}`} />
            <span className={`absolute left-0 top-2 h-0.5 w-5 rounded-full bg-ink transition duration-200 ${isOpen ? "opacity-0" : ""}`} />
            <span className={`absolute left-0 top-[14px] h-0.5 w-5 rounded-full bg-ink transition duration-200 ${isOpen ? "-rotate-45 translate-y-[-9px]" : ""}`} />
          </span>
        </button>
      </div>

      {isOpen && (
        <nav className="border-t border-line bg-white px-4 pb-4 pt-2 md:!hidden" aria-label="Mobile navigation">
          <div className="section-shell flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setIsOpen(false)}
                className={({ isActive }) =>
                  `rounded-2xl px-4 py-3 text-sm font-bold transition ${
                    isActive ? "bg-gotrip-100 text-gotrip-800" : "text-muted hover:bg-gotrip-50 hover:text-gotrip-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <div className="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-2">
              <Link to="/rooms" onClick={() => setIsOpen(false)} className="btn-secondary">Explore stays</Link>
              <Link to="/foods" onClick={() => setIsOpen(false)} className="btn-primary">Book dining</Link>
            </div>
          </div>
        </nav>
      )}
    </header>
  );
};

export default BaseHeader;
